import esIdentity from './es-MX/identity.json';

export const identityTranslations = {
  'es-MX': esIdentity,
};

export { registerIdentityTranslations, areIdentityTranslationsLoaded } from './registerTranslations';
